import { render, staticRenderFns } from "./User.vue?vue&type=template&id=4bfc1d54&scoped=true"
import script from "./User.vue?vue&type=script&lang=js"
export * from "./User.vue?vue&type=script&lang=js"
import style0 from "./User.vue?vue&type=style&index=0&id=4bfc1d54&prod&lang=less&scoped=true"
import style1 from "./User.vue?vue&type=style&index=1&id=4bfc1d54&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfc1d54",
  null
  
)

export default component.exports